var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconWalletconnect = function SvgIconWalletconnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0c6.628 0 12 5.372 12 12s-5.372 12-12 12S0 18.628 0 12 5.372 0 12 0Z",
    fill: "url(#icon-walletconnect_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.626 9.267c2.414-2.358 6.333-2.358 8.747 0l.29.286a.294.294 0 0 1 0 .427l-.993.97c-.061.06-.16.06-.22 0l-.399-.39a4.39 4.39 0 0 0-6.103 0l-.427.418c-.06.061-.16.061-.22 0l-.994-.97a.295.295 0 0 1 0-.427l.319-.314Zm10.805 2.006.886.863a.295.295 0 0 1 0 .427l-3.99 3.895a.314.314 0 0 1-.435 0l-2.832-2.766a.08.08 0 0 0-.107 0L9.12 16.458a.314.314 0 0 1-.436 0l-4.003-3.895a.295.295 0 0 1 0-.427l.886-.863a.314.314 0 0 1 .436 0l2.831 2.766a.08.08 0 0 0 .108 0l2.831-2.766a.314.314 0 0 1 .436 0l2.832 2.766a.08.08 0 0 0 .107 0l2.832-2.766a.332.332 0 0 1 .45 0Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-walletconnect_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(24 0 0 24 0 12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })))));
};

export default SvgIconWalletconnect;